// Environmental Configurations for connecting Production API Endpoint with Production UI Setup
export const environment: string = 'prod';
export const logger: string = 'debug';

export const appConfig = {

  // Authentication Details
  'loginUrl': 'https://id.trimble.com/oauth/authorize',
  'logoutUrl': 'https://id.trimble.com/oauth/logout',
  'tokenUrl': 'https://id.trimble.com/oauth/token',
  'profileEndpoint': 'https://cloud.api.trimble.com/apicloudx/user/me',
  'landingUrl' : 'https://api.trimblepaas.com/landing',

  // API Details
  'apiEndpoint' : 'https://cloud.api.trimble.com/apicloudv2/apix/v1/',
  'xApiKey': '3fd21969-f8e9-4b7b-be83-77e239a03cfa',
  'homePage': '/apicloud',
  'relyingParty': 'apicloud',
  'WikiUrl': {
      'publishApi' : 'https://docs-apix.trimblepaas.com/apicloudx/csh/context-sensitive-help/publish-an-api/index.html',
      'consumeApi' : 'https://docs-apix.trimblepaas.com/apicloudx/csh/context-sensitive-help/consume-an-api-in-trimble-store/index.html'
  },
  // Documentation Url
  'apiDocsUrl' : 'https://api.trimblepaas.com/apidocs?application=trimble&swaggerUrl='


};

export const themes = {
  'light-blue-skin'  : {'fg-color' : 'light', 'landing-fg-color': 'dark' },
  'dark-blue-skin'   : {'fg-color' : 'light', 'landing-fg-color': 'dark'  },
  'one-trimble-skin' : {'fg-color' : 'dark', 'landing-fg-color': 'dark'  }
};

export const stores = {
  'trimble': {
      'applicationName': 'apix',
      'consumerKey': '777ec3c5-38fc-4e5c-bf4d-ad7aa83b87e6',
      'clientSecret': '6681be9b982c44ce9bdabd23e8c5ddba',
      'callbackUrl': 'https://api.trimblepaas.com/auth/session',

      'storeId': 'f4834b34-5eaf-4b20-8292-451a77260c7a',
      'storeName': 'APIX-UI-Store',
      'description': 'APIX-UI-Store',
      'supportTeamEmail': 'tpaas_helpdesk@trimble.com',

      'theme': 'light-blue-skin',
      'defaultGateway': 'AWS',
      'gateways' : [
          {
              name: 'AWS',
              description: 'Amazon Web Service',
              regions: ['Oregon']
          }/*,
          {
              name: 'WSO2',
              description: 'Web Service Oxygen',
              regions: []
          }*/
      ]
  },
  'visionlink': {
      'applicationName': 'Prod-VLConnect',
      'consumerKey': 'WKbWCeL6wPrwqPfAv4vHr3sBVLga',
      'callbackUrl': 'https://unifiedapi.myvisionlink.com/auth/session',

      'storeId': '2712531c-3952-11e7-8492-063042922089',
      'storeName': 'APIX-UI-Store',
      'description': 'APIX-UI-Store',
      'supportTeamEmail': 'vl_support@trimble.com',

      'theme': 'dark-blue-skin',

      'defaultGateway': 'AWS',
      'gateways' : [
          {
              name: 'AWS',
              description: 'Amazon Web Service',
              regions: ['Oregon']
          }/*,
          {
              name: 'WSO2',
              description: 'Web Service Oxygen',
              regions: []
          }*/
      ]
  },
  'trimbleInternal': {
      'applicationName': 'Trimble-Internal-Store',
      'consumerKey': 'sQ58e1DUTmuU_7gvAWT6_tJ3Tm0a',
      'callbackUrl': 'https://api.trimblepaas.com/auth/session',

      'storeId': 'cc28c420-3ea4-4513-aad7-e66aee755c63',
      'storeName': 'Internalstore',
      'description': 'Internal trimble store',
      'supportTeamEmail': 'tpaas_helpdesk@trimble.com',

      'theme': 'light-blue-skin',
      'landingContent': 'trimble',

      'defaultGateway': 'WSO2',
      'gateways' : [
          {
              name: 'WSO2',
              description: 'Web Service Oxygen',
              regions: []
          },
          {
              name: 'AWS',
              description: 'Amazon Web Service',
              regions: ['Oregon']
          }
      ]
  }
};




// WEBPACK FOOTER //
// C:/Users/sthanga1/Documents/apicloud-x/apicloud-x/apim-ui-newgen/src/environments/environment.ts